<template>
  <div class="recruitPage" v-if="!this.showLoad">
    <div class="warp">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.departmentName"
          v-if="mode != 'add'"
          :required="editType"
          readonly
          label="所属部门："
          class="ggInput"
        />
        <van-field
          v-model="userinfo.departmentName"
          v-else
          required
          readonly
          label="所属部门："
          class="ggInput"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary">
        <van-field
          :required="editType"
          v-model="baseData.jobTitle"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
          class="ggInput"
          label="招聘岗位："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          :required="editType"
          v-model="baseData.recruitingNum"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
          class="ggInput"
          label="招聘人数："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          :required="editType"
          v-model="jobTypeName"
          @click="showJobShow"
          :placeholder="editType ? '请选择' : ''"
          readonly
          :is-link="editType"
          class="ggInput"
          label="职位类型："
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary">
        <van-field
          :required="editType"
          v-model="baseData.educationName"
          :placeholder="editType ? '请选择' : ''"
          readonly
          @click="educationshow"
          :is-link="editType"
          class="ggInput"
          label="学历要求："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.specialty"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
          class="ggInput"
          label="专业要求："
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary moreLeaveText"
        v-if="baseData.workExperience != null"
      >
        <van-field
          :required="editType"
          v-model="baseData.workExperience"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
          class="ggInput"
          label="工作经验要求："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="genderName"
          :required="editType"
          label="性别要求："
          readonly
          :placeholder="editType ? '请选择' : ''"
          @click="showSex"
          :is-link="editType"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="baseData.ageRange"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
          class="ggInput"
          label="年龄要求："
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary payBox reson">
        <p>薪资待遇：</p>
        <div class="payInput clearfix">
          <van-field
            :required="editType"
            v-model="baseData.salaryMin"
            :placeholder="editType ? '请输入最小值' : ''"
            :readonly="!editType"
            type="digit"
            class="ggInput fl"
          />
          <van-field
            v-model="baseData.salaryMax"
            :placeholder="editType ? '请输入最大值' : ''"
            :readonly="!editType"
            type="digit"
            class="ggInput fr"
          />
          <span class="jgf">~</span>
        </div>
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary reson moreText"
        v-if="baseData.reason != null"
      >
        <p>申请补充人员原因：</p>
        <van-field
          v-model="baseData.reason"
          :required="editType"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
          rows="1"
          autosize
          type="textarea"
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group
        class="baseNone baseSalary reson moreText"
        v-if="baseData.jobDescriptions != null"
      >
        <p>岗位工作要求描述（工作内容及主要职责）：</p>
        <van-field
          v-model="baseData.jobDescriptions"
          :required="editType"
          :placeholder="editType ? '请输入...  ' : ''"
          :readonly="!editType"
          class="ggInput"
          rows="1"
          autosize
          type="textarea"
        />
      </van-cell-group>

      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="mode !== 'add' && baseData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="baseData"></audit-list>
      </div>
      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="mode !== 'add' && baseData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="baseData"></flow-staff>
        <flow-list :workflowCode="baseData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="baseData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="baseData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput('edit')"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        baseData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          baseData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          baseData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <!-- 弹出层 -->
    <!-- 性别选择 -->
    <van-popup v-model="showSexPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="sexList"
        value-key="name"
        @cancel="showSexPicker = false"
        @confirm="saveSexMode"
      />
    </van-popup>
    <!-- 职位类型 -->
    <van-popup v-model="jobTypeShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="jobTypeList"
        value-key="name"
        @cancel="jobTypeShow = false"
        @confirm="saveJobMode"
      />
    </van-popup>
    <!-- 学历弹框 -->
    <van-popup v-model="showEducationPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="educationList"
        value-key="dictName"
        @cancel="showEducationPicker = false"
        @confirm="saveEducationMode"
      />
    </van-popup>
    <!-- 网络失败 -->
    <refresh-page v-if="refreshPagePicker" />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");

const flowList = () => import("@/components/common/flowList");
const flowStaff = () => import("@/components/common/flowStaff");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
import {
  dateTimeFormat,
  intervalTime,
  diffMonth,
  getDictList,
  isEdit,
} from "@/utils/common";
import { getDeviceType, closePage,is_wei } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "recruitPage",
  data() {
    return {
      mode: "add",
      editType: false, //能否编辑
      baseUrl: process.env.BASE_URL,
      refreshPagePicker: false,
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      baseData: {
        id: "", //招聘需求Id
        deptId: "", //部门Id
        departmentName: "", //部门名称
        ageRange: "", //年龄要求
        deptNumbers: "", //部门人数
        education: "", //学历字典
        educationName: "", //学历名称
        gender: "", //性别：0,无；1,男；2,女
        jobDescriptions: "", //职位描述
        jobTitle: "", //职位名称
        jobType: "", //职位类型 qz.全职；wb,外包；jz,兼职
        recruitingNum: "", //招聘人数
        salaryMax: "", //薪资待遇（最大）
        salaryMin: "", //薪资待遇（最小）
        specialty: "", //专业要求
        workExperience: "", //工作 经验
        reason: "", //原因
        verifyStatus: "hold", //审核状态 hold,暂存;pending,待审核;doing,审核中;pass,通过;deny,拒绝
        baseAnnexes: [], //附件
      },
      jobTypeName: "", //职位类型名称
      jobTypeShow: false, //职位类型
      jobTypeList: [
        { name: "全职", value: "qz" },
        { name: "外包", value: "wb" },
        { name: "兼职", value: "jz" },
      ], //qz.全职；wb,外包；jz,兼职
      educationList: [], //学历列表
      genderName: "", //性别名称
      sexList: [
        { name: "无", value: "0" },
        { name: "男", value: "1" },
        { name: "女", value: "2" },
      ],
      showSexPicker: false,
      showEducationPicker: false, //学历弹框
      clientType: getDeviceType(),
      sendType: "", //判断是否在抄送列表
    };
  },
  components: {
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  async mounted() {
    if (is_wei()) {
      document.title = "招聘申请";
    }
    this.educationList = await getDictList("xueli");
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑 verify 审批
    window.editPage = this.editPage; //编辑页面
    this.$nextTick(function () {
      this.editType = this.mode == "add" ? true : false;
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.userinfo && this.userinfo.id) {
        this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
        this.baseData.applicantName =
          this.mode == "add" ? this.userinfo.realName : "";
        this.baseData.applicantId = this.mode == "add" ? this.userinfo.id : "";
      }
      this.mode !== "add" ? (this.commonId ? this.getDetails() : "") : "";
    });
  },
  methods: {
    ...mapMutations(["setShowLoad", "setAppData"]),
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    /*获取详情*/
    getDetails() {
      let _this = this;
      _this.$api.userCenter.user.recruit
        .recruitDetail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = res.data;
            _this.jobTypeName = _this.getJobTypeName(_this.baseData.jobType);
            _this.genderName = _this.getSexTypeName(_this.baseData.gender);
            if (_this.baseData.specialty == null) {
              _this.$set(_this.baseData, "specialty", "");
            }
            if (_this.baseData.ageRange == null) {
              _this.$set(_this.baseData, "ageRange", "");
            }
            if (_this.baseData.salaryMax == null) {
              _this.$set(_this.baseData, "salaryMax", "");
            }

            if (
              (_this.baseData.verifyStatus == "hold" ||
                _this.baseData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
        });
    },
    /*获取性别控件*/
    showSex() {
      if (this.editType) {
        this.showSexPicker = true;
      }
    },
    saveSexMode(data) {
      this.showSexPicker = false;
      this.genderName = data.name;
      this.baseData.gender = data.value;
    },
    getSexTypeName(type) {
      let name = "";
      if (type == "0") {
        name = "无";
      } else if (type == "1") {
        name = "男";
      } else if (type == "2") {
        name = "女";
      } else {
        name = "";
      }
      return name;
    },
    //职位类型
    showJobShow() {
      if (this.editType) {
        this.jobTypeShow = true;
      }
    },
    saveJobMode(data) {
      this.jobTypeShow = false;
      this.jobTypeName = data.name;
      this.baseData.jobType = data.value;
    },
    getJobTypeName(type) {
      let name = "";
      if (type == "qz") {
        name = "全职";
      } else if (type == "wb") {
        name = "外包";
      } else if (type == "jz") {
        name = "兼职";
      } else {
        name = "";
      }
      return name;
    },
    /*选择学历*/
    educationshow() {
      if (this.editType) {
        this.showEducationPicker = true;
      }
    },
    saveEducationMode(data) {
      this.showEducationPicker = false;
      this.baseData.educationName = data.dictName;
      this.baseData.education = data.dictCode;
    },
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    /*提交表单*/
    checkInput(msg) {
      let _this = this;
      /*校验*/

      if (
        _this.baseData.deptId &&
        _this.baseData.education &&
        _this.baseData.gender &&
        _this.baseData.jobDescriptions &&
        _this.baseData.jobTitle &&
        _this.baseData.jobType &&
        _this.baseData.recruitingNum &&
        _this.baseData.workExperience &&
        _this.baseData.salaryMin &&
        _this.baseData.reason
      ) {
        _this.mode = msg;
        _this.saveAll();
      } else {
        _this.$toast("带星号为必填，不能为空");
      }
    },
    /*保存接口*/
    saveAll() {
      let _this = this;
      _this.btnLoading = true;
      let updateData = {
        ageRange: _this.baseData.ageRange,
        baseAnnexes: [],
        deptId: _this.baseData.deptId,
        education: _this.baseData.education,
        gender: _this.baseData.gender,
        id: _this.baseData.id,
        jobDescriptions: _this.baseData.jobDescriptions,
        jobTitle: _this.baseData.jobTitle,
        jobType: _this.baseData.jobType,
        reason: _this.baseData.reason,
        recruitingNum: _this.baseData.recruitingNum,
        salaryMax: Number(_this.baseData.salaryMax),
        salaryMin: Number(_this.baseData.salaryMin),
        specialty: _this.baseData.specialty,
        workExperience: _this.baseData.workExperience,
      };
      console.log(JSON.stringify(updateData));
      _this.$api.userCenter.user.recruit
        .addRecruit(_this.mode, updateData)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          _this.$toast("网络失败，稍后重试");
          _this.btnLoading = false;
        });
    },
    /*撤回/删除*/
    delApply() {
      let _this = this;
      let msg = _this.baseData.verifyStatus == "hold" ? "删除" : "撤回";
      _this.$dialog
        .confirm({
          title: "确认" + msg,
          message: "您确认要" + msg + "当前申请?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.userCenter.user.recruit
            .delApply(_this.baseData.verifyStatus, _this.baseData.id)
            .then((res) => {
              if (res.code == "1") {
                let text = msg + "成功";
                closePage(text);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              _this.$toast("网络失败，稍后重试");
              _this.btnLoading = false;
            });
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
          this.baseData.applicantName =
            this.mode == "add" ? this.userinfo.realName : "";
          this.baseData.applicantId =
            this.mode == "add" ? this.userinfo.id : "";
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.recruitPage {
  width: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;
  height: 100%;

  .warp {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding-bottom: 75px;
  }
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }
  #searchHeight {
    text-align: left;
  }
  .baseNone.reson {
    min-height: 45px;
    p {
      padding: 10px 16px 0 16px;
      font-size: 15px;
      color: #323233;
    }
  }
  .van-cell,
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreLeaveText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.payBox {
    width: 100%;
    .payInput {
      width: 100%;
      padding: 15px 10%;
      position: relative;
      .ggInput {
        display: inline-block;
        width: 40%;
        border: 1px solid #f6f6f6;
        padding: 5px 5px;
        margin-right: 10%;
        .van-field__control {
          text-align: left;
        }
      }
      .ggInput:nth-child(2) {
        margin: 0;
      }
      .jgf {
        font-size: 18px;
        color: #666;
        position: absolute;
        top: 22px;
        left: 50%;
        margin-left: -5px;
      }
    }

    .ggInput.van-cell::after {
      content: none;
    }
    .van-cell--required::before {
      left: -30px;
      top: -35px;
    }
  }
  .reson.moreText {
    .van-field__control {
      text-align: left;
    }
    .van-cell--required::before {
      top: -20px;
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      height: 45px;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        display: inline-block;
        height: 45px;
        line-height: 45px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin: 10px 0 45px 0;
  }
  //审批操作样式
}
</style>